export const FORMULARIOS = () => '/formularios';
